export default __webpack_public_path__ + "static/media/email.ec32c6a9.png";